import { Menu } from '../../cdl-react-components/components'
import Link from '../../Utilities/Link'

const navigation = (props) => {
    return (
        <Menu handle={<span className={props.className} style={{ cursor: 'pointer' }}>MENU</span>}>
            <Link href="/">Home</Link>
            <Link href="/about">About&nbsp;the&nbsp;Digest</Link>
            <Link href="/faq">Frequently&nbsp;Asked&nbsp;Questions</Link>
            {/* <Link href="/contact">Contact</Link> */}
            <Link href="https://cdl.canadiandiscovery.com/corporate/contact">Contact</Link>
            <Link href="/editions">Print&nbsp;Archives</Link>
            <Link href="/privacy-policy">Privacy&nbsp;Policy</Link>
            <Link href="/terms-use">Terms&nbsp;of&nbsp;Use</Link>
        </Menu>
    )
}

export default navigation